import isArray from 'lodash/isArray';
import isObject from 'lodash/isObject';

export const pascalCase = (str) =>
    str
        .replace(/[^a-z0-9]+/gi, ' ')
        .replace(/(\w)(\w*)/g, (g0, g1, g2) => `${g1.toUpperCase()}${g2.toLowerCase()}`)
        .replace(/\s+/gi, '');

export const isMessage = (message) => isObject(message) && typeof message.id !== 'undefined';

export const getComponentFromName = (name, components, defaultComponent = null) => {
    if (name === null) {
        return null;
    }
    const componentName = pascalCase(name);
    return components[componentName] || defaultComponent;
};

export const cleanExternalLinks = (str) =>
    str !== null
        ? str.replace(/(<a\\b[^<>]*href=['"]?http[^<>]+)>/gi, '$1 target="_blank">')
        : null;

export const getImageAtSize = (image, size, webp = false) => {
    if (image === null) {
        return null;
    }
    const { sizes: imagesSizes = [], ...originalImage } = image || {};
    return (
        [...(isArray(size) ? size : [size]), 'original']
            .reduce(
                (acc, currentSize) =>
                    webp ? [...acc, `${currentSize}_webp`, currentSize] : [...acc, currentSize],
                [],
            )
            .reduce(
                (selectedImage, currentSize) =>
                    selectedImage ||
                    (imagesSizes || []).find(({ id }) => id === currentSize) ||
                    null,
                null,
            ) || originalImage
    );
};

export const addNonBreakingSpaces = (str) => str.replace(/&nbsp;/g, '\u00a0');

export const getCurrencySymbol = (currency) => {
    const currencySymbolsMap = {
        cad: '$',
        usd: '$',
        eur: '€',
        mxn: '$',
        jpy: '¥', // ¥ not available with current font (FRAC)
    };
    const symbol = currencySymbolsMap[currency.toLowerCase()];
    return typeof symbol !== 'undefined' ? symbol : '$';
};
